/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack, SxProps, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { tagStyle } from "./tagStyle.ts";
import { mergeSx } from "@/src/utils/mergeSx.ts";

export type TagProps = {
  label: string;
  sx?: SxProps<Theme>;
};

export default function Tag({ label, sx }: TagProps) {
  return (
    <Stack direction={"row"} sx={mergeSx(tagStyle.container, sx)}>
      <Typography variant={"body1"}>{label}</Typography>
    </Stack>
  );
};
